<template>

<div>
    <div v-if="params.data.confirmed_at">
        Confirmed
    </div>
    <div v-else class="cursor-pointer">
        <a @click="showConfirmationPopup(params.data)">Verify</a>
    </div>

    <speakol-confirmation-popup
      v-on:hide-confirmation-popup="isConfirmationPopupVisible = false"
      v-on:confirm="confirmTransaction"
      :showConfirmationPopup="isConfirmationPopupVisible"
      :title="'Add fund confirmation'"
      :body="confirmationPopupBody"
    />
</div>

</template>

<script>
export default {

  data () {

    return {
      isConfirmationPopupVisible: false,
      confirmationPopupBody: ''
    }
  },


  methods: {

    showConfirmationPopup (transaction) {
      this.confirmationPopupBody = `Are you sure you want to confirm transaction #${transaction.id}`
      this.uuid = transaction.uuid
      this.isConfirmationPopupVisible = true
    },

    async confirmTransaction () {
      const uuid = this.params.data.uuid
      this.isConfirmationPopupVisible = false
      await window.axios.post(`/payments/confirm/${uuid}`)

      this.params.node.setData({
        ...this.params.node.data,
        confirmed_at: new Date()
      })
      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })

    }
  }
}
</script>

<style lang="scss" scoped>
</style>